export default Object.freeze({
    Individual: 0,
    MultipleClients: 1
})